import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { SidebarDocumentsStore } from './SidebarDocumentsStore';

export * from './SidebarDocumentsStore';

export const { Provider: SidebarDocumentsStoreProvider, useStore: useSidebarDocumentsStore } =
  createContextLocalStore(SidebarDocumentsStore);
